import { jsPDF } from 'jspdf';
import { registerTrainingFonts } from './trainingCertFonts.js';

export const PDF_LAYOUT_VERSION = '2026-10-print-v6-form9';
export const GREEN: [number, number, number] = [20, 64, 38];
export const INK: [number, number, number] = [17, 24, 39];
export interface InspectionRow { number: string; label: string; value: string }

export function formatPDFDate(value?: string): string {
  if (!value) return '';
  const clean = value.trim();
  const iso = clean.match(/^(\d{4})[-/.](\d{1,2})[-/.](\d{1,2})(?:T.*)?$/);
  const local = clean.match(/^(\d{1,2})[-/.](\d{1,2})[-/.](\d{4})$/);
  if (iso) return `${iso[3].padStart(2, '0')}/${iso[2].padStart(2, '0')}/${iso[1]}`;
  if (local) return `${local[1].padStart(2, '0')}/${local[2].padStart(2, '0')}/${local[3]}`;
  return clean;
}

export function newPDF(title: string): jsPDF {
  const doc = new jsPDF({ unit: 'mm', format: 'a4', compress: true, putOnlyUsedFonts: true });
  registerTrainingFonts(doc);
  doc.setProperties({ title, creator: 'G&G EHS', subject: PDF_LAYOUT_VERSION });
  doc.setFont('Inter', 'normal');
  doc.setTextColor(...INK);
  return doc;
}

/** Fit uploaded signatures and seals without stretching their aspect ratio. */
export function placeImage(doc: jsPDF, image: string | null | undefined, x: number, y: number, w: number, h: number) {
  if (!image) return;
  try {
    const info = doc.getImageProperties(image);
    const scale = Math.min(w / info.width, h / info.height);
    const iw = info.width * scale, ih = info.height * scale;
    doc.addImage(image, info.fileType, x + (w - iw) / 2, y + (h - ih) / 2, iw, ih);
  } catch { /* Optional image may be absent or invalid; keep the signature space. */ }
}

export function textLines(doc: jsPDF, value: string, width: number, size: number, bold = false): string[] {
  doc.setFont('Inter', bold ? 'bold' : 'normal');
  doc.setFontSize(size);
  return doc.splitTextToSize((value || '-').replace(/[\u2010-\u2015]/g, '-'), width);
}
